import { gql } from '@apollo/client';

export const ALL_PORTFOLIOS = gql`
  query GetPortfolios($input: PortfolioFilterInput!) {
    portfolios: getPortfolios(input: $input) {
      id
      name
      isArchived
      creator {
        id
        firstName
        lastName
        email
      }
      assignedTo {
        id
        firstName
        lastName
        email
      }
      programmeCount
      reportersCount
      geographies {
        id
        name
      }
    }
  }
`;
